<ion-list class="ion-no-padding">
    <ng-container *ngFor="let language of languages; let i=index;">
        <ion-item detail="false" lines="none" button class="ion-text-center" (click)="dismiss(i)">
            <ion-img class="flag-svg"
                [src]=" language.languageFlagUrl"
            ></ion-img>
            <ion-label>
                <h3>
                    {{ language.languageLabel }}
                </h3>
            </ion-label>
        </ion-item>
        <div class="divider-dark"></div>
    </ng-container>
</ion-list>
